<template>
  <div class="outer-box" >
    <h4>Skip Payment Intent And Enable Isv</h4>

    <div class="inner-box" style="text-align: left; width: 500px;">
      <input
        class="hl_input--wrap "
        type="text"
        placeholder="Relationship Number"
        v-model="relationshipNumber"
      />
      <button class="btn btn-primary mt-4" @click="skipPaymentIntentForAgency">
        <moon-loader v-if="processing" :loading="true" size="21px" color="#fafafa" />
        <span v-else> Skip 3DS Verification </span>
      </button>
      <pre v-if="response" style="background-color: #f2f7fa;padding: 16px; margin-top: 16px">{{response}}</pre>
    </div>
  </div>
</template>

<script>
import { SaasService } from "@/services";

export default {
  data() {
    return {
      relationshipNumber: '',
      processing: false,
      response: null
    };
  },
  methods: {
    async skipPaymentIntentForAgency() {
      try{
        this.processing = true;
        this.response = (await SaasService.skipIsv3dsVerification(this.relationshipNumber)).data
      }
      catch (err) {
          this.response = err.response.data
      }
      finally {
          this.processing = false;
      }
    }
  }
}
</script>
